import { I18n } from '@calendly/i18n';
import { IconChevronRight } from '@calendly/ui/components/glyphs/IconChevronRight';
import { IconHelpCircle } from '@calendly/ui/components/glyphs/IconHelpCircle';
import { UiIcon } from '@calendly/ui/components/ui-icon';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { LearnMoreButton } from 'components/page_elements';
import { SHARE_NOTETAKER_RECAPS_HELP_URL } from '../constants';
import { BaseState } from './base_state';
const linkContainerCss = "lpk92wj";
const LinkContainer = forwardRef((props, ref) => <span ref={ref} {...props} className={classNames(linkContainerCss, props.className)} />);
export const EmptySharedList = () => <BaseState heading={I18n.t('publisher.recaps.shared_with_me.empty_state.title')} ctaButton={<LearnMoreButton as="a" href={SHARE_NOTETAKER_RECAPS_HELP_URL} target="_blank" rel="noopener noreferrer" aria-label={I18n.t('publisher.recaps.shared_with_me.empty_state.learn_more')}>
        <LinkContainer>
          <UiIcon icon={IconHelpCircle} size="small" title="" />
          {I18n.t('publisher.recaps.shared_with_me.empty_state.learn_more')}
          <UiIcon icon={IconChevronRight} size="small" title="" />
        </LinkContainer>
      </LearnMoreButton>} />;

require("./empty_shared_list.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./empty_shared_list.js");